import React from 'react';
import Loading from './../components/Loading';

function Services() {

  return (
  <>
    <Loading></Loading>
    <main class="main">
      <p>Services</p>
    </main>
  </>  
  );
}

export default Services;